import { combineEpics } from 'redux-observable';
import { tap } from 'rxjs/operators/tap';
import { ignoreElements } from 'rxjs/operators/ignoreElements';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { generatePath } from 'react-router-dom';
import { withLatestFrom } from 'rxjs/operators/withLatestFrom';

import { distinctUntilChanged } from 'rxjs/operators/distinctUntilChanged';
import { SET_ROUTE, SET_URL, SYNC_ROUTE } from '../actions/routes';

import { increment } from '../actions/loading';
import { clearErrors } from '../actions/errors';

const isSamePathname = (prev, curr) =>
  prev.location.pathname === curr.location.pathname;

const setRouteEpic = (action$, state$, { history }) =>
  action$.ofType(SET_ROUTE).pipe(
    withLatestFrom(state$),
    tap(
      ([
        { value, params: newParams },
        {
          routes: {
            match: { params: currentParams },
          },
        },
      ]) => {
        const params = { ...currentParams, ...newParams };

        history.push(generatePath(value, params));
      }
    ),
    ignoreElements()
  );

const setUrlEpic = (action$, state$, { loadUrl }) =>
  action$.ofType(SET_URL).pipe(
    tap(({ value }) => loadUrl(value)),
    mergeMap(() => of(increment(), { type: 'EPIC_END' }))
  );

const clearDisplayedErrorsEpic = (action$) =>
  action$.ofType(SYNC_ROUTE).pipe(
    distinctUntilChanged(isSamePathname),
    mergeMap(() => of(clearErrors()))
  );

const routesEpic = combineEpics(
  setRouteEpic,
  clearDisplayedErrorsEpic,
  setUrlEpic
);

export { setRouteEpic, clearDisplayedErrorsEpic, setUrlEpic };

export default routesEpic;
